import React from "react";
import { ChatField } from "../ChatField";
import { FieldDisplayRendererProps } from "./types";

export const ChatDisplayRenderer = ({
  field,
  value,
  item,
}: FieldDisplayRendererProps) => {
  return <ChatField field={field} value={value} id={item.id} />;
};
